import * as React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Overlay from '../Overlay';

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  box-sizing: border-box;
  margin: 0 auto;
`;

const Root = ({ children, overlay }) => (
  <Wrapper>{overlay.opened ? <Overlay /> : children}</Wrapper>
);

Root.defaultProps = {
  overlay: {}
};

Root.propTypes = {
  children: PropTypes.node.isRequired,
  overlay: PropTypes.object
};

const mapStateToProps = state => ({
  overlay: state.overlay
});

export default connect(mapStateToProps)(Root);



// WEBPACK FOOTER //
// ./src/components/Layout/Root.jsx